import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import { Container, Typography } from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PrincipalContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "NSS",
  };

  componentDidMount() {
    let d = {
      dept_code: "NSS",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Principal's Message" />

        <Container className="mb-5">
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                  {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}

                  <div>
                  <div>
                        <div style={{ textAlign: "left" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            // src={require("./image/principal.jpg")}
                            style={{
                              width: "350px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div>

                        {/* <h5
                          style={{
                            fontSize: "16px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}<br />
                          Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya<br />
						               Eraligool, Sribhumi
                        </h5> */}
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          {/* <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a> */}
                        </h6>
                      </div>
                    <div>
                      <Typography
                        variant="h6"
                        style={{ margin: "1em 0", fontWeight: 700 }}
                        gutterBottom
                      >
                        WELCOME MESSAGE FROM THE PRINCIPAL
                      </Typography>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        It gives me immense pleasure to extend my heartfelt greetings to all members of the National Service Scheme (NSS) Unit of Dispur College. The NSS plays a vital role in shaping socially responsible citizens and fostering a spirit of selfless service among our students.
                        <br/>
                        Our College takes pride in the dedication, enthusiasm, and commitment exhibited by the NSS volunteers in organizing community service initiatives, awareness programs, and outreach activities. These endeavours not only contribute to the well-being of society but also cultivate leadership, empathy, and teamwork among our students.
                        <br/>
                        I warmly invite all interested students to join the NSS and become a part of this transformative journey. By participating, you will have the opportunity to develop essential life skills, build lasting friendships, gain valuable exposure to social issues, and make a meaningful impact in the community. Your involvement will also enhance your personal growth and contribute to your holistic development as responsible and compassionate citizens.
                        <br/>
                        I encourage the NSS Unit to continue its exemplary work and inspire more students to actively participate in service-oriented activities. Your efforts reflect the true essence of social responsibility and bring great honor to Dispur College.
                        <br/>
                        I wish all the members of the NSS Unit continued success in their noble mission of serving society.

                      </Typography>

                      <br />

                      {/* <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        The Mahavidyalaya commenced its maiden academic journey from the academic session 2017-2018, offering Higher Secondary (10+2) courses in Science under Assam Higher Secondary Education Council, Bamunimaidam, Guwahati, and Under-graduate (UG) Science programmes leading to Bachelor of Science (B.Sc.) under Assam University, Silchar. Now, the Mahavidyalaya has emerged as a truly multidisciplinary higher education institution by offering Four-Year Under-graduate (FYUG) Programmes in both Arts and Science streams based on the NEP 2020 curriculum, under Assam University, Silchar, from the academic session 2023-2024. While the FYUG Programmes in Science are offered in six subjects, such as Physics, Chemistry, Mathematics, Botany, Zoology, Statistics; the FYUG Programmes in Arts are offered in seven subjects that include English, Bengali, Economics, Education, Sociology, Political Science, and History. It is to be mentioned here that the FYUG Programmes in Arts were introduced at the Mahavidyalaya from the academic session 2023-2024.
                      </Typography> */}

                      {/* <br/>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >In order to provide high-quality Arts and Science education at the UG level, the Mahavidyalaya has an appropriate infrastructure in place, including academic buildings and laboratories. Various workshops focusing on different aspects of Arts and Science education and research, as well as numerous co-curricular activities, are regularly organized on the days of national significance. The Mahavidyalaya has successfully completed infrastructure projects such as the construction of girls’ hostel, boundary walls, and residential complexes for Staff and Sports buildings. Plans are underway to establish a gymnasium for the fitness needs of both the students and employees. Further infrastructure development includes the construction of a Canteen and an academic annex building. The Mahavidyalaya is currently making preparations for the first cycle of visit by the National Assessment and Accreditation Council (NAAC) during the current academic session.</Typography>
                      <br /> */}
                      {/* <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >I express my gratitude to the Hon’ble the then District Commissioner, Sribhumi cum Founder President, Governing Body of our Mahavidyalaya, Mr. P. K. Talukdar , ACS, for allocating an additional five bighas of land for the Mahavidyalaya's playground. NSS, Eraligool is dedicated to providing skill-based knowledge, fostering inclusive education, promoting participatory culture, and instilling a value-oriented approach alongside its regular courses, aligning with the NEP 2020 of the Government of India. The Mahavidyalaya is committed to advancing its academic dimensions through high-quality teaching, innovative pedagogical techniques, and research to cater to the requirements of Arts and Science education. It is with great privilege that I announce the presence of well-qualified, experienced, and enthusiastic teachers who are devoted to their vocation. This educational institution will be instrumental in enabling students to attain academic and intellectual achievements.</Typography>


                      <br /> */}

                      

                      <div>
                        {/* <div style={{ textAlign: "right" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "250px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div> */}

                        <h4
                          style={{
                            fontSize: "20px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          Dr. Navajyoti Borah<br />
                          Dispur College<br />
						               Dispur, Guwhati
                        </h4>
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          {/* <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a> */}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Container>
      </div>
    );
  }
}
